import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SidebarService } from '../../shared/sidebar/sidebar.service'
import { RequestService } from '../../../services/request.service';

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss']
})

export class FullLayoutComponent implements OnInit {

    constructor(
        public sidebarservice: SidebarService,
        private router: Router,
        private request : RequestService,
    ) { }
        
    toggleSidebar() {
        this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
    }
    
    getSideBarState() {
        return this.sidebarservice.getSidebarState();
    }

    hideSidebar() {
        this.sidebarservice.setSidebarState(true);
    }

    ngOnInit() {
        this.ViewEmployee(Number(localStorage.getItem('employeeId')));

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        }

        async ViewEmployee(empId){
        try {
            const employee = {
                'employeeId': empId
            };
            const data: any = await this.request.post('/hrms/view_employee/',employee);
            for (let objKey of Object.keys(data)) {
                let dataObj = data[objKey];
                if(objKey=="result"){
                    for (let objKey1 of Object.keys(dataObj)) {
                        // this.employeeDetails = dataObj[objKey1];
                        // console.log(">> "+dataObj[objKey1].activeStatus);
                        if(dataObj[objKey1].activeStatus=="active"){

                        }else{
                            localStorage.clear();
                            this.router.navigate(['/auth/signin']);
                        }
                    } 
                }				
            }
            await new Promise(resolve => setTimeout(() => resolve(this.ViewEmployee(empId)), 10000));
            } catch (error) {}
        }

    //-----------------session logout code-----------------------------------
    // Set timeout variables.
    // timoutWarning = 540000; // Display warning in 9 Mins.
    // timoutNow = 600000; // Timeout in 10 mins.
    timoutWarning = 120000;
    timoutNow = 180000;
    warningTimer;
    timeoutTimer;
    // Start timers.
    StartTimers() {
        this.warningTimer = setTimeout(()=>{                           
            this.IdleWarning()
        }, this.timoutWarning);

        this.timeoutTimer = setTimeout(()=>{                           
            this.IdleTimeout()
        }, this.timoutNow);
    }
    // Reset timers.
    ResetTimers() {
        //alert("123");
        clearTimeout(this.warningTimer);
        clearTimeout(this.timeoutTimer);
        
        this.StartTimers();

    }
    // Show idle timeout warning dialog.
    IdleWarning() {
        console.log("warning...");
    }
    // Logout the user.
    IdleTimeout() {
        localStorage.clear();
        this.router.navigate(['/auth/signin']);
    }

}